import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FeatureFlagsTestingRootComponent } from './feature-flags-testing-root.component';
import { HiddenPathFeatureComponent } from './hidden-path-feature.component';
import { canLoadFeature } from '../lib/routing/can-load-feature';
import { FeatureFlagsModule } from '../lib/feature-flags.module';

const routes: Routes = [
  {
    path: '',
    component: FeatureFlagsTestingRootComponent,
  },
  {
    path: 'worksWhenTestFlagIsOn',
    canActivate: [canLoadFeature],
    data: {
      feature: 'TestFlag',
    },
    component: HiddenPathFeatureComponent,
  },
];

@NgModule({
  imports: [FeatureFlagsModule, CommonModule, RouterModule.forChild(routes)],
  declarations: [FeatureFlagsTestingRootComponent, HiddenPathFeatureComponent],
  exports: [],
  providers: [],
})
export class FeatureFlagsTestingModule {}
